module.exports = __webpack_public_path__ + "media/react/pages/mock_tests/free/about_magoosh_content/assets/map-034ebe933311e87c14ce634ee66c0086.svg";